// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const falinks: PokeData = {
  "id": 870,
  "name": "falinks",
  "height": 30,
  "weight": 620,
  "base_experience": 165,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "counter",
    "focus-energy",
    "reversal",
    "protect",
    "endure",
    "megahorn",
    "rock-smash",
    "iron-defense",
    "bulk-up",
    "close-combat",
    "first-impression",
    "no-retreat"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "protect",
    "rock-smash",
    "bulk-up",
    "close-combat",
    "karate-chop",
    "double-kick",
    "coaching",
    "drain-punch",
    "jump-kick",
    "rolling-kick",
    "superpower"
  ],
  "evolution_chain": {
    "id": 453,
    "item": null,
    "species": [
      {
        "name": "falinks",
        "order": 870,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 117,
    "speed": 121,
    "ability_power": 162
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
